import React from 'react'
import SettingApiForm from '../components/setting/settingControlForm'

const SettingIndex = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingIndex